import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card,Popover, IconButton, } from '@mui/material';
import * as React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getApi } from 'views/services/api';
import { useEffect } from 'react';
import AddComplaint from './AddComplaint';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem from '@mui/material/MenuItem';
import DeleteComplaint from './DeleteComplaint';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// ----------------------------------------------------------------------

const Complaint = () => {
  const navigate = useNavigate();
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [complaintId, setComplaintId] = useState();
  const [complaintData, setcomplaintData] = useState([]);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [rowData, setRowData] = useState();

  // functions for opening the dialog boxes ---------------------------------

  // function for  delete dialog/////////////////////////////////////
  const handleOpenDeleteComplaint = (id) => {
    setComplaintId(id);
    setOpenDelete(true);
  };
  const handleCloseDeleteComplaint = () => setOpenDelete(false);
  // function for add dialog/////////////////////////////////////

  const handleOpenAddComplaint = () => setOpenAdd(true);
  const handleCloseAddComplaint = () => setOpenAdd(false);

  const handleOpenview = (complaintId) => {
    console.log("id ==>",complaintId);
    navigate(`/dashboard/complaint/view/${complaintId}`);
  };

  // function for fetching all the rooms data from the db

  const fetchcomplaintData = async () => {
    try {
      const response = await getApi(`api/complaint/viewallcomplaints/${hotel?.hotelId}`);
      setcomplaintData(response?.data?.complaintData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchcomplaintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openDelete]);


  const handleClick = (event, row) => {
    console.log("row on click ==>",row);
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const columns = [
    {
      field: 'type',
      headerName: 'Complaint Type',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'description',
      headerName: 'Complaint Description',
      flex: 1
    },
    {
      field: 'createdDate',
      headerName: 'Created At',
      flex: 1,
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      }
    },
    {
      field: 'status',
      headerName: 'Complaint Status',
      flex: 1,
      cellClassName: `name-column--cell--capitalize`,
      renderCell: (params) => {
        return params?.value === true ? (
          <Box sx={{ backgroundColor: '#42a142', color: 'white', padding: '10px', borderRadius: '10px' }}>Resolved</Box>
        ) : (
          <Button variant="contained" disabled>
            Pending
          </Button>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,

      renderCell: (params) => {
        return (
          <>
            <div>
              <IconButton aria-describedby={params?.row._id} variant="contained" onClick={(event) => handleClick(event, params?.row)}>
                <MoreVertIcon />
              </IconButton>
              <Popover
                id={params?.row._id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
              >
                <MenuItem onClick={() => handleOpenview(params.row._id)} disableRipple>
                  <VisibilityIcon style={{ marginRight: '8px', color: 'green' }} />
                  View
                </MenuItem>
                <MenuItem onClick={() => handleOpenDeleteComplaint(params.row._id)} sx={{ color: 'red' }} disableRipple>
                  <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
                  Delete
                </MenuItem>
              </Popover>
            </div>
            {/* <MenuItem onClick={() => handleOpenview(params.row._id)} disableRipple>
              <VisibilityIcon style={{ marginRight: '8px', color: 'green' }} />
              View
            </MenuItem>
            <MenuItem onClick={() => handleOpenDeleteComplaint(params.row._id)} sx={{ color: 'red' }} disableRipple>
              <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
              Delete
            </MenuItem> */}
          </>
        );
      }
    }
  ];

  return (
    <>
      <AddComplaint open={openAdd} handleClose={handleCloseAddComplaint} />
      <DeleteComplaint open={openDelete} handleClose={handleCloseDeleteComplaint} id={complaintId} />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Typography variant="h4">Complaint-Management</Typography>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAddComplaint}>
              Add Complaint
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Complaints ( {complaintData?.length || 0} )
              </Typography>
              {complaintData && (
                <DataGrid
                  rows={complaintData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default Complaint;
